/* src/app/pages/project/map/repository/import-wizard/components/geospatial/step0-kmz-kml-import-feature-list/import-wizard-geospatial-features-list.component.scss */
:host {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  padding: 1rem;
  overflow: hidden;
}
.grid-container {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: 1fr;
  gap: 0 1rem;
  flex: 1;
  min-height: 0;
}
.preview-map-container {
  grid-column: span 2;
  height: 45%;
  border-radius: 12px;
  overflow: hidden;
  align-self: start;
}
.features-list-container {
  grid-column: span 5;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-height: 0;
  overflow: hidden;
}
.features-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-height: 0;
  overflow-y: auto;
  flex: 1;
  padding-right: 1rem;
}
.features-list > app-geospatial-feature-card {
  opacity: 0;
  animation: fadeCascade 0.25s ease forwards;
}
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
}
.filter-container {
  display: flex;
  gap: 0.3rem;
  flex-shrink: 0;
}
.filter-container > .search-input-dimension {
  margin-bottom: 12px;
}
.footer-container {
  display: grid;
  grid-template-columns: 1fr 2fr;
  flex-shrink: 0;
}
.footer-container span {
  font-size: 14px;
  color: var(--primary);
  margin-bottom: 4px;
}
.button-container {
  display: flex;
  justify-content: flex-end;
  gap: 0 1rem;
  margin-top: 1rem;
  flex-shrink: 0;
}
.button-container > button {
  background: #FACC15;
  color: #2a2a2a;
  border: none;
  border-radius: 6px;
  padding: 8px 24px;
  font-size: 14px;
  font-weight: 600;
  flex-shrink: 0;
  cursor: pointer;
  width: fit-content;
  height: fit-content;
  transition: all 0.2s ease;
}
.button-container > button:hover {
  background: #FACC15;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.3);
}
.button-container > button:active {
  transform: translateY(0);
}
.button-container > button.secondary {
  background: #444444;
  color: #ffffff;
}
.button-container > button.secondary:hover {
  background: #3d3d3d;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}
app-single-select {
  width: 100%;
  max-width: 250px;
}
app-single-select ::ng-deep .select-box {
  background: #FACC15;
}
app-single-select ::ng-deep .select-box:hover:not(.disabled) {
  background: #FACC15;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.3);
}
app-single-select ::ng-deep .select-box.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
app-single-select ::ng-deep .selected-text {
  color: #2a2a2a;
  font-weight: 600;
}
app-single-select ::ng-deep .arrow {
  color: #2a2a2a;
}
.pending-list-progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  margin: auto;
}
.pending-list-progress-bar {
  --mdc-linear-progress-active-indicator-color: var(--primary);
}
.pending-list-progress-bar {
  --mdc-linear-progress-active-indicator-height: 10px;
}
.pending-list-progress-bar {
  --mdc-linear-progress-track-color: #505050;
}
.pending-list-progress-bar {
  --mdc-linear-progress-track-height: 10px;
}
/*# sourceMappingURL=import-wizard-geospatial-features-list.component-IJDN5VE2.css.map */
